import { Link} from "@tanstack/react-router";
import roadShowImage from "../assets/roadShow/roadShow.png";
import { Button } from "../components/ui/button";

const RoadShowPage: React.FC = () => {
	
	return (
		<main className="py-3 px-safe-offset-3 min-h-[calc(100vh-176px)] overflow-x-hidden max-w-[890px] mx-auto">
			<h3 className="text-base font-medium text-fontheader my-4">
				Roadshow LTCA to niepowtarzalny cykl spotkań stacjonarnych z ekspertami
				LTCA w kilkunastu miastach w Polsce.
			</h3>
			<img alt="roadshow LTCA 2025" src={roadShowImage} />
			<p className="text-base text-fontheader my-4">
				Oprócz wykładów merytorycznych, porozmawiamy o wykorzystaniu AI w
				podatkach, odpowiemy na Wasze pytania w ramach sesji Q&A i podyskutujemy
				wspólnie w ramach networkingu!
			</p>
			<Link to="https://akademialtca.pl/roadshow-ltca-2025">
			<Button
				className=" w-full border-[1px] border-slate-200 bg-gradient-to-r from-[#1A0506] to-[#C12829] text-white"
				variant="ghost"
			>
				Dowiedz się więcej
			</Button>
			</Link>
		</main>
	);
};

export default RoadShowPage;
